import React from 'react'

const PageHeader = ({ children }) => {
  return (
    <div className='flex items-center justify-between pb-4'>{children}</div>
  )
}

export default PageHeader
